export default __webpack_public_path__ + "static/media/kraken.9ea471be.png";